/**
 * 面板版本：首页展示用。
 * 发版规范：版本号使用 semver，releaseDate 使用 YYYY-MM-DD；两者必须同时更新。
 */
export const PANEL_VERSION = '0.2.0';
export const PANEL_RELEASE_DATE = '2026-10-31';
export const PANEL_VERSION_LABEL = `v${PANEL_VERSION} · ${PANEL_RELEASE_DATE}`;
